import React from "react";

import "./card_label.less";
import { Skeleton, Tooltip } from "antd";

interface CardLabelProps {
  label: string;
  toolTip?: string;
  children: React.ReactNode | string;
  showToolTip?: boolean;
  isLoading?: boolean;
}

const CardLabel: React.FC<CardLabelProps> = ({
  label,
  toolTip,
  children,
  showToolTip = true,
  isLoading,
}) => {
  return (
    <div className="card-label">
      {isLoading ? (
        <Skeleton paragraph={{ rows: 1 }} />
      ) : (
        <>
          <h6>{label}</h6>
          <label>
            <Tooltip
              placement="top"
              title={showToolTip ? toolTip || children : ""}
            >
              <div className="card-label__content">{children}</div>
            </Tooltip>
          </label>
        </>
      )}
    </div>
  );
};

export default CardLabel;
